export const DEFAULT_ORGANIZATION_NAME = 'Default Organization'
export const DEFAULT_FIELD_OF_ACTIVITY = 'OTHER'
